import React, { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import moment from 'moment';
import { Box, Flex } from '@chakra-ui/react';

import { useApi } from '@app/hooks';
import { SharedPhotoDescriptor } from '@app/api/share';

import { USER_DATE_TIME_FORMAT } from '../../utils/constants';
import Logo from '../common/icons/logo';
import FieldView from '../common/field-view';
import { Paper } from '../common';

const Share: FC = () => {
  const [notFound, setNotFound] = useState(false);
  const [info, setInfo] = useState<SharedPhotoDescriptor>();
  const api = useApi();

  const location = useLocation();
  useEffect(() => {
    (async () => {
      const info = await api.share.getPhotoShare(location.hash.slice(1));
      if (info.code === 404) {
        setNotFound(true);
      } else {
        setInfo(info.data);
      }
    })();
  }, [location]);

  return (
    <>
      <Box
        paddingX={{ xs: 1, sm: 2, md: 10, lg: 14, xl: 20 }}
        marginX="auto"
        alignSelf="center"
        textAlign="center"
        maxH="100vh"
      >
        <Paper>
          <Box paddingX={2} paddingY={3}>
            <Flex flexDirection='column' gap={2}>
              <Flex backgroundColor="brand.500" alignItems='center' mt={-3} mx={-2}>
                <Logo variant="horizontal" />
              </Flex>
              <Box>
                {notFound && 'Информация отсутствует'}
              </Box>

              {info && (
                <Flex 
                  flexDirection='column' 
                  gap={2}
                  maxH='100%'
                  maxW='100%'
                >
                  <Box maxH='calc(100vh - 300px)'>
                    <img
                      src={'data:image/jpeg;base64,' + info.photo.content}
                      alt={info.photo.filename}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        maxHeight: 'inherit',
                      }}
                    />
                  </Box>
                  <Box
                    display="flex"
                    justifyContent="flex-start"
                    flexDirection="column"
                    alignItems="flex-start"
                  >
                    {info.visit_dt && (
                      <FieldView
                        title="Дата визита"
                        value={moment(info.visit_dt).format(
                          USER_DATE_TIME_FORMAT
                        )}
                        direction="row"
                      />
                    )}
                    {info.outlet && (
                      <FieldView
                        title="Торговая точка/Склад"
                        value={info.outlet.name}
                        direction="row"
                      />
                    )}
                    {info.full_address && (
                      <FieldView
                        title="Адрес"
                        value={info.full_address}
                        direction="row"
                      />
                    )}
                    {info.user && (
                      <FieldView
                        title="Пользователь"
                        value={info.user}
                        direction="row"
                      />
                    )}
                  </Box>
                </Flex>
              )}
            </Flex>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default Share;
